const CALENDLY = {
    onReady() {
        CALENDLY.activateOnClick();
    },
    activateOnClick() {
        const button = document.getElementById('activate-calendly');
        if (button === null) return;
        button.addEventListener('click', event => {
            event.preventDefault();
            let cookieStr = COOKIE.get({ name: TRACKING.cookieName });
            let cookieObj = cookieStr.split(',');
            var cookieArr = [];
            cookieObj.forEach(element => {
                if (element !== 'calendly=false') {
                    cookieArr.push(element); 
                }
            });
            cookieArr.push('calendly=true');
            let newCookieStr    = cookieArr.join(',');
            const storeDuration = cookieArr.includes('google_analytics=false') ? 1 : 730;
            COOKIE.set({
                name:  TRACKING.cookieName, 
                value: newCookieStr, 
                days:  storeDuration
            });
            location.reload();
        });
    }
}